<cds-loading-overlay *ngIf="!programs; else programDropdown" [primaryMessage]="'Loading Programs'"
  [secondaryMessage]="'Wait a moment while we retrieve your programs.'"></cds-loading-overlay>

<ng-template #programDropdown>
  <div>
    {{reportDescription}}
  </div>
  <br />

  <p class='program-count'>{{selectedRows ? selectedRows?.length : 0}} Program(s) selected</p>
  <div class='select-program grid-container'>
    <cds-datagrid name="programList" [data]="programs" [initialSelection]="initialSelectedPrograms" [flexHeight]="true" [stickyHeaders]="true"
    (selectionChange)="onSelect($event)">

      <cds-datagrid-header>
        <cds-smart-datagrid-checkbox-header></cds-smart-datagrid-checkbox-header>
      </cds-datagrid-header>

      <cds-datagrid-header cdsSmartDatagridSort key="program_code_list" cdsDatagridSort  [active]="true" [direction]="1"  >Program Number</cds-datagrid-header>
      <cds-datagrid-header cdsSmartDatagridSort key="key" >Program Name</cds-datagrid-header>
      <cds-datagrid-header cdsSmartDatagridSort key="coverage_types_list">Coverage Type</cds-datagrid-header>


      <ng-template cdsRowTemplate let-row keyProp="key">
        <cds-datagrid-row [data]="row"  keyProp="key" cdsSmartDataGridSelect>

          <cds-datagrid-cell>
            <cds-smart-datagrid-checkbox-cell></cds-smart-datagrid-checkbox-cell>
          </cds-datagrid-cell>

          <cds-datagrid-cell>{{ row.program_code_list }}</cds-datagrid-cell>
          <cds-datagrid-cell>{{ row.key }}</cds-datagrid-cell>
          <cds-datagrid-cell>{{ row.coverage_types_list }}</cds-datagrid-cell>

        </cds-datagrid-row>
      </ng-template>


      <cds-paginator cdsDataGridPaginator cdsSmartDataGridPaginator [offset]="0" [pageSize]="10" [totalResults]="programs.length"
        [pageSizes]="[5, 10, 20, 30]" [hidePageSizeSelector]="true" [recordLabel]="'program'">
      </cds-paginator>
    </cds-datagrid>
  </div>
</ng-template>